import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import * as ActionType from './constants';


const handleErrors = (response) => {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
};

export const setProductId = payload => ({  // used in route.js
  type: ActionType.SET_PRODUCT_ID,
  payload,
});

export const setProjectType = projectType => ({
  type: ActionType.SET_PROJECT_TYPE,
  payload: {
    projectType
  }
});

export const setSkuId = payload => ({  // used in route.js
  type: ActionType.SET_SKU_ID,
  payload,
});

export const setCustomizationUUID = payload => ({
  type: ActionType.SET_CUSTOMIZATION_UUID,
  payload,
});

export const prefillInvitationTemplate = payload => ({
  type: ActionType.PRE_FILL_RENDER_CARDS,
  payload,
});

const receiveProjectOrder = payload => ({
  type: ActionType.RECEIVE_PROJECT_ORDER_VIEW,
  payload
});

const requestUpdateCustomization = () => ({
  type: ActionType.REQUEST_UPDATE_CUSTOMIZATION,
});

const receiveCustomization = payload => ({
  type: ActionType.RECEIVE_CUSTOMIZATION,
  payload
});

export const setSilhouette = label => ({
  type: ActionType.SET_SILHOUETTE,
  label
});

const receiveRSVPCardsDisabled = () => ({
  type: ActionType.RECEIVE_RSVP_CARDS_DISABLED,
});

export const setCompletedMenu = payload => ({
  type: ActionType.SET_COMPLETED_MENU,
  payload,
});

const receiveProject = payload => ({
  type: ActionType.RECEIVE_PROJECT,
  payload
});

export const setCurrentStep = step => ({
  type: ActionType.SET_CURRENT_STEP,
  payload: {
    step
  }
});

export const selectQuantity = quantity => ({
  type: ActionType.SELECT_QUANTITY,
  quantity,
});

export const selectSize = size => ({
  type: ActionType.SELECT_SIZE,
  size,
});

export const receiveCanceledOrder = order => ({
  type: ActionType.RECEIVE_CANCELED_ORDER,
  payload: {
    order
  }
});

export const setFooterLabel = (name, label) => ({
  type: ActionType.SET_FOOTER_LABEL,
  name,
  label,
});

export const setActiveField = activeField => ({
  type: ActionType.SET_ACTIVE_FIELD,
  payload: {
    activeField
  }
});

export const requestProjectGuestIds = () => ({
  type: ActionType.REQUEST_PROJECT_GUEST_IDS
});

export const receiveProjectGuestIds = projectGuestIds => ({
  type: ActionType.RECEIVE_PROJECT_GUEST_IDS,
  payload: {
    projectGuestIds
  }
});

export const requestProjectAuthentication = () => ({
  type: ActionType.REQUEST_PROJECT_AUTHENTICATION
});

export const receiveProjectAuthentication = () => ({
  type: ActionType.RECEIVE_PROJECT_AUTHENTICATION
});

export const resetSelectedGuestIds = () => ({
  type: ActionType.RESET_SELECTED_GUEST_IDS,
});

export const loadProject = projectUUID => (
  dispatch => (
    fetch(`/web-api/v1/card/projects/${projectUUID}`,
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(response => response.json())
    .then((json) => {
      json.customization_templates.forEach((customization) => {
        dispatch(receiveCustomization(customization));
      });
      dispatch(receiveProject({ project: json }));
      return json;
    })
  )
);

export const loadCustomization = uuid => (
  (dispatch, getState) => { // eslint-disable-line
    return fetch(`/web-api/v1/card/projects/customization/${uuid}`, {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    })
    .catch(() => {
      if (uuid === getState().cards.cardCustomization.rsvp.uuid) {
        dispatch(receiveRSVPCardsDisabled());
      }
    });
  }
);

export const createProject = (skuId, quantity) => (
  (dispatch) => {
    const requestBody = {
      sku_object_id: skuId,
      quantity
    };
    return fetch('/web-api/v1/card/projects',
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
      .then(response => response.json())
      .then((json) => {
        json.customization_templates.forEach((customization) => {
          dispatch(receiveCustomization(customization));
        });
        dispatch(receiveProject({ project: json }));
        return json;
      });
  }
);

export const updateCustomization = (customizationUUID, customizationData) => { //eslint-disable-line
  return (dispatch) => {
    dispatch(requestUpdateCustomization());
    const customizationRequest = _.values(customizationData).filter(customizationValue => !_.isEmpty(customizationValue));
    const sanitizedRequest = customizationRequest.map((customizationValue) => {
      const { body } = customizationValue;
      if (body) {
        const trimmedBody = body.replace(/\r?\n|\r/g, ' ');
        return { ...customizationValue, body: trimmedBody };
      }
      return customizationValue;
    });
    if (!_.isEmpty(customizationRequest)) {
      return fetch(`/web-api/v1/card/projects/customization/${customizationUUID}`, {
        credentials: 'same-origin',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(sanitizedRequest)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(receiveCustomization(json));
        return json;
      });
    }
    return true;
  };
};

export const fetchProjectOrder = projectUUID => (
  dispatch => (
    fetch(`/web-api/v1/card/projects/${projectUUID}/order_view`,
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => response.json())
      .then((json) => {
        dispatch(receiveProjectOrder(json));
        return json;
      })
    )
);

export const toggleBackCustomization = (customizationUUID, bool) => {
  const toggleBackCustomizationRequest = {
    back_enabled: bool,
  };
  return (dispatch) => {
    fetch(`/web-api/v1/card/projects/customization/${customizationUUID}/toggle_back`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toggleBackCustomizationRequest)
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    });
  };
};

export const toggleAddMealOptions = (customizationUUID, bool) => {
  const toggleAddMealOptionsRequest = {
    meal_options_enabled: bool
  };
  return (dispatch) => {
    fetch(`/web-api/v1/card/projects/customization/${customizationUUID}/toggle_meal_options`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toggleAddMealOptionsRequest)
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    });
  };
};

export const toggleAddRSVPCards = (bool, projectUUID) => {
  const requestBody = {
    rsvp_enabled: bool
  };
  return (dispatch, getState) => {
    fetch(`/web-api/v1/card/projects/customization/${projectUUID}/toggle_rsvp`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then((json) => {
      const { deleted } = json;
      if (deleted) {
        dispatch(receiveRSVPCardsDisabled());
      } else {
        const customizationUUID = getState().cards.cardCustomization.rsvp.uuid;
        dispatch(loadCustomization(customizationUUID));
      }
    });
  };
};

/* both Envelope and RSVPEnvelope */
export const toggleEnvelopePrinting = (customizationUUID, bool) => {
  const requestBody = {
    envelope_printing_enabled: bool
  };
  return (dispatch) => {
    fetch(`/web-api/v1/card/projects/customization/${customizationUUID}/toggle_envelope_printing`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    });
  };
};

export const updateLinerColor = (customizationUUID, linerColor) => {
  const requestBody = {
    linerColor
  };
  return (dispatch) => {
    fetch(`/web-api/v1/card/projects/customization/${customizationUUID}/update_liner_color`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(receiveCustomization(json));
      return json;
    });
  };
};

export const toggleRecipientAddressing = (customizationUUID, bool) => (
  (dispatch) => {
    const requestBody = {
      recipientAddressing: bool
    };
    return fetch(`/web-api/v1/card/projects/customization/${customizationUUID}/toggle_recipient_addressing`, {
      credentials: 'same-origin',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then(json => dispatch(receiveCustomization(json)));
  }
);

export const deleteProjectDraft = (projectUUID) => { // eslint-disable-line
  return dispatch => ( // eslint-disable-line
    fetch('/web-api/v1/card/projects/delete',
      {
        credentials: 'same-origin',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ projectUUID })
      })
      .then(response => response.json())
      .then((json) => { // eslint-disable-line
        // console.log(json);
        return json;
      })
  );
};

export const updateProjectQuantity = (projectUUID, quantity) => { // eslint-disable-line
  return (dispatch) => { // eslint-disable-line
    fetch(`/web-api/v1/card/projects/${projectUUID}/quantity`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ quantity })
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(receiveProjectOrder(json));
        return json;
      });
  };
};

export const cloneProject = (projectUUID) => { // eslint-disable-line
  return (dispatch) => ( // eslint-disable-line
    fetch(`/web-api/v1/card/projects/${projectUUID}/clone`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        json.customization_templates.forEach((customization) => {
          dispatch(receiveCustomization(customization));
        });
        dispatch(receiveProject({ project: json }));
        return json;
      })
  );
};

export const addProjectToCart = (projectUUID) => { // eslint-disable-line
  return dispatch => ( // eslint-disable-line
    fetch('/web-api/v1/card/projects/cart',
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ projectUUID })
      })
      .then(handleErrors)
  );
};

export const cancelOrder = (orderUUID) => { // eslint-disable-line
  return dispatch => (
    fetch(`/web-api/v1/card/orders/${orderUUID}/cancel`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveCanceledOrder(json)))
  );
};

export const getMediaFileUrl = mediaFileUUID => (
  dispatch => ( // eslint-disable-line
    fetch(`/web-api/v1/card/projects/media_file/${mediaFileUUID}/presigned_url`,
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(handleErrors)
      .then(response => response.text())
  )
);

export const getProjectGuestIds = projectUUID => (
  (dispatch) => {
    dispatch(requestProjectGuestIds());
    return fetch(`/web-api/v1/card/projects/${projectUUID}/guests`,
      {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveProjectGuestIds(json)));
  }
);

export const getProjectAuthenticated = projectUUID => (
  (dispatch) => {
    dispatch(requestProjectAuthentication());
    return fetch(`/web-api/v1/card/projects/${projectUUID}/is_authenticated`,
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ projectUUID })
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((auth) => {
        dispatch(receiveProjectAuthentication(auth));
        return auth;
      });
  }
);
    // .then(json => dispatch(receiveProjectGuestIds(json)));

export const updateProjectGuestIds = (projectUUID, projectGuestIds) => (
  (dispatch) => {
    const requestBody = {
      recipients: projectGuestIds
    };
    return fetch(`/web-api/v1/card/projects/${projectUUID}/guests`,
      {
        credentials: 'same-origin',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveProjectGuestIds(json)));
  }
);



/** WEBPACK FOOTER **
 ** ./src/cards/actions/cardProjectActions.js
 **/